/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IStoreSelectorViewProps } from '@msdyn365-commerce-modules/store-selector';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const StoreSelectorView: React.FC<IStoreSelectorViewProps> = props => {
    const {
        BodyContainerProps,
        FooterContainerProps,
        HeaderContainerProps,
        HeaderProps,
        ModuleProps,
        // headerText,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        noLocationsMessage,
        terms
    } = props;
    const currentUrl = ModuleProps.moduleProps.context.request.url.requestUrl.href;
    const baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/') + 1);
    React.useEffect(() => {
        const titles = Array.from(document.querySelectorAll('.ms-store-select__location-line-item-store-name'));
        if (titles.length > 0) {
            titles.forEach(el => {
                const storeName = el.textContent;
                if (storeName && storeName.startsWith('R ')) {
                    el.closest('.ms-store-select__location-line-item')?.classList.add('location-type__dealer');
                    el.textContent = storeName.replace('R ', '');
                }
                // @ts-ignore
                if (props.config.renderLinkToStorePage) {
                    const goToStoreCtn = el.closest('.ms-store-select__location-line-item')?.querySelector('.go-to-store');
                    if (goToStoreCtn === null) {
                        const storeUrl = storeName
                            ?.replace('R ', '')
                            .toLowerCase()
                            .replace(/[ .&@',]/g, '-')
                            .replace(/-+/g, '-');
                        const goToStore = document.createElement('div');
                        goToStore.className = 'go-to-store';
                        // tslint:disable-next-line:no-inner-html
                        goToStore.innerHTML = `<a target="_blank" href="${baseUrl}${storeUrl}">${
                            // @ts-ignore
                            props.resources.goToStorePage ? props.resources.goToStorePage : 'Go to Store page'
                        }</a>`;
                        el.closest('.ms-store-select__location-line-item:not(.location-type__dealer)')
                            ?.querySelector('.ms-store-select__location-line-item-content')
                            ?.appendChild(goToStore);
                    }
                }
            });
        }
    }, [locationsList]);

    return (
        <Module {...ModuleProps}>
            <Node {...HeaderContainerProps}>{HeaderProps}</Node>
            <Node {...BodyContainerProps}>
                {locationsMessage}
                {search}
                {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>}
            </Node>
            <Node {...FooterContainerProps}>{terms}</Node>
        </Module>
    );
};

export default StoreSelectorView;
